<div class="container-fluid">
 <app-pagetitle title="GAMES" [breadcrumbItems]="breadCrumbItems"></app-pagetitle> 

<div class="main-card-container">
  <div class="card">
    <div class="card-body">
      <button class="btn btn-secondary" [routerLink]="'/boards'">Back to boards</button>
      <div class="dropdown float-end" ngbDropdown>
        <a href="javascript: void(0);" class="dropdown-toggle arrow-none card-drop" ngbDropdownToggle
          data-toggle="dropdown" aria-expanded="false">
          <i class="mdi mdi-dots-vertical"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a href="javascript:void(0);" class="dropdown-item">Export Games</a>
        </div>
        <i class="mdi mdi-refresh" (click)="refresh()" ngbTooltip="Refresh"></i>
      </div>
      <h4 class="card-title mb-4">Game</h4>
      <div class="table-responsive">
        <button type="button" class="btn btn-primary" style="height:50px;width:200px;" (click)="onAddNew(addEditModal)">Add New Game</button>
        <div class="col-sm-12 col-md-12">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end"><label
              class="d-inline-flex align-items-center">Search:
              <input type="text" name="searchTerm" class="form-control form-control-sm ms-2"
                aria-controls="tickets-table" [(ngModel)]="term" /></label></div>
        <table class="table table-centered">
          <thead class="table-light">
            <tr>
              <th>Game Name</th>
              <th>Version</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of game|filter:term">
              <td>{{item.name}}</td>
              <td>{{item.version}}</td>
              <td>
                <a (click)="onEdit(addEditModal, item)" class="me-3 text-primary" ngbTooltip="Edit" ><i
                    class="mdi mdi-pencil font-size-50"></i></a>
                <a (click)="onDelete(item.id)"  class="text-danger" ngbTooltip="Delete"><i
                    class="mdi mdi-trash-can font-size-18"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <ng-template #addEditModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="add-edit-modal-title">{{addEditMode}}</h4>
      <button class="btn btn-warn close" (click)="modal.dismiss('Cross click')">Close</button>
    </div>
    <div class="modal-body">
      <form [formGroup]="gameFormGroup">
        <div class="form-group">
          <label for="name-input" style="font-size: 20px;" style="font-family: Arial;">Game Name</label>
          <input type="text" class="form-control" id="gameName-input" 
          formControlName="name"
            aria-describedby="name" placeholder="Enter Game Name">
        </div>
        <div class="form-group">
          <label for="version-input" style="font-size: 20px;" style="font-family: Arial;">Verison</label>
          <input type="text" class="form-control" id="version-input" 
            formControlName="version"
            aria-describedby="version" placeholder="Enter Version">
        </div>
       
      </form>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary btn-outline-dark" style="height:50px;width:200px;"(click)="modal.close('Save click')">Save</button>
    </div>
  </ng-template>
</div>